import React from 'react';
import path from 'path';
import AppWrapper from '../app_wrapper';
import DesignerListComponent from '../components/pages/DesignerList';
import { apiGet } from '../modules/api';
import { DESIGNERS_LIST_PAGE } from '../helpers/pageHelper';
import metadata from '../helpers/metadataHelper';

const DesignerList = props => (
  <>
    <AppWrapper
      desktopComp={<DesignerListComponent {...props} />}
      mobileComp={<DesignerListComponent {...props} />}
      currPage={DESIGNERS_LIST_PAGE}
      metadata={metadata.designerList}
    />
  </>
);

DesignerList.getInitialProps = ({ store, req, res }) => {
  const { departmentName } = req.params;

  let url = 'api/brands/';
  if (departmentName !== undefined) {
    url = path.join(url, departmentName);
  }
  return store.dispatch(apiGet(url, req, res));
};

export default DesignerList;
